import React from 'react'

class EnabledFullHorizontalMenuIconComponent extends React.Component {
  render () {
    return (
      <div style={styles.enabledSection}>
        <button style={styles.button}>
          <img src={this.props.img} alt='true' style={styles.icon} /><br />
          <span style={styles.enabledLabel}>{this.props.label}</span>
        </button>
      </div>
    )
  }
}

const styles = {
  enabledSection: {
    top: '0px',
    margin: '0px 0px 0px -3px',
    padding: '0px 2px 2px 3px',
    borderWidth: '2px',
    borderBottom: '2px white solid',
    width: '112px',
    height: '68px',
    float: 'left',
    borderColor: '#7ED321'
  },
  button: {
    cursor: 'pointer',
    backgroundColor: 'Transparent',
    border: 'none',
    width: '112px',
    height: '68px'
  },
  icon: {
    marginTop: '1px',
    width: '38px',
    height: '40px'
  },
  enabledLabel: {
    fontSize: '10px',
    fontWeight: 'bold',
    fontStyle: 'normal',
    color: '#7ED321'
  }
}

export default EnabledFullHorizontalMenuIconComponent
